/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Description_PlaceholderInputs */

const en_product_description_placeholder = /** @type {(inputs: Product_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product description`)
};

const es_product_description_placeholder = /** @type {(inputs: Product_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripcion del producto`)
};

/**
* | output |
* | --- |
* | "Product description" |
*
* @param {Product_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const product_description_placeholder = /** @type {((inputs?: Product_Description_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Description_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_product_description_placeholder(inputs)
	return es_product_description_placeholder(inputs)
});